<template>
  <div class="button-spacer">
    <button
      v-on="$listeners"
      v-bind="$attrs"
      class="button"
      :class="buttonClass"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    buttonClass: {
      type: String
    }
  }
}
</script>

<style scoped>
.button-spacer {
  margin-top: 40px;
  margin-bottom: 20px;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  background: transparent;
  padding: 10px 100px 10px 100px;
  border: none;
  border-radius: 3px;
  text-align: center;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  font-weight: 400;
  white-space: nowrap;
  transition: all 0.2s linerar;
}
.button.-fill-gradient {
  /* background: var(--primary); */
  background: var(--primary);
  color: #ffffff;
}
.button.-fill-gradient-cta {
  /* background: linear-gradient(to right, #f7901e, #c46428); */
  background: var(--primary);
  color: #ffffff;
}
.button:active {
  animation: pulse 0.25s infinite ease-out;
}
.button:hover {
  transform: scale(1);
  box-shadow: none;
}

.button:focus {
  outline: 0;
}
.button:disabled {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

@media screen and (max-width: 560px){
  .button {
    padding: 10px 20px;
  }
}
</style>
